<template>
   <az-table :data="table.data"
             :rowPainted="table.rowPainted" />
</template>
 
<script>
import AzTable from '@/components/AZTable';
export default {
    name: 'main-table',
    components: {AzTable},
    props:['data','lease'],
    
    data() {
      return {
          table:{
              data: [
                  ['Precio Esperado', this.data['precio_referencia']+' USD/t', 0],
                  ['Rinde Esperado', this.data['rinde_presupuestado']+' qq/ha', 0],
                  ['Ingreso Bruto', this.data['ingreso_bruto']+' USD/ha',1],
                  ['Gastos Comerciales', this.data['gastos_comerciales']+' USD/ha', 0],
                  ['Ingreso Neto', this.data['ingreso_neto']+' USD/ha', 1],
                  ['Implantación', this.data['implantacion']+' USD/ha',0],
                  ['Protección', this.data['proteccion']+' USD/ha',0],
                  ['Gerenciamiento', this.data['gerenciamiento']+' USD/ha',0],
                  ['Cosecha', this.data['cosecha']+' USD/ha',0],
                  ['Margen Bruto', this.data['margen_bruto']+' USD/ha', 1],  
                  (this.lease) ? ['Arrendamiento', this.data['arrendamiento']+' USD/ha',0] : ['','',0],
                  ['Margen Neto', this.data['margen_neto']+' USD/ha', 1]  
                  
              ]
              
          }
      }        
  },
    
}
</script>
